import React, {useEffect, useMemo, useState} from "react";
import {ButtonGroup, Card, CardContent} from "@mui/material";
import Meta from "../common/Meta";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import {formatDateMask} from "../common/Utils";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {getCalendarSchedule} from "../common/api/WebApi";
import {useNavigate} from "react-router-dom";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";

export default function EmployeeCalendar(props) {
  const navigate = useNavigate();

  const [scheduleMode, setScheduleMode] = useState(true);

  function renderEventContent(eventInfo) {

    let bgColor = '#8d5b84';
    let fontColor = '#fff';

    let scheduledTime = eventInfo?.event?.extendedProps?.scheduledTime;

    if (scheduledTime) {
      bgColor = '#5b6f8d';
      fontColor = '#fff';
    }

    if (eventInfo?.event?.extendedProps?.employee?.backgroundColor) {
      bgColor = eventInfo?.event?.extendedProps?.employee?.backgroundColor;
    }
    if (eventInfo?.event?.extendedProps?.employee?.fontColor) {
      fontColor = eventInfo?.event?.extendedProps?.employee?.fontColor
    }

    return (
      <Card
        style={{
          backgroundColor: bgColor
        }}
        className={"w-100"}>
        <CardContent>
          <MDTypography variant="p" style={{
            color: fontColor
          }} fontWeight="bold">
            {eventInfo.event?.title}<br/>
            <MDTypography variant="p" style={{
              color: fontColor
            }} fontWeight="regular">
              {eventInfo.event?.extendedProps?.displayTime} {eventInfo.event?.extendedProps.scheduledTime && <><p><Icon>access_time</Icon>&nbsp;Scheduled</p></>}
            </MDTypography>
          </MDTypography>
        </CardContent>
      </Card>
    )
  }

  const toolbar = {
    left: 'prev,next',
    center: 'title',
    right: 'timeGridDay,dayGridWeek,dayGridMonth' // user can switch between the two
  };

  const handleDatesSet = (info) => {
    let startDate = new Date(info.start);
    startDate.setHours(0, 0, 0, 0);
    let endDate = new Date(info.end);

    let req = {
      startDate: startDate,
      endDate: endDate,
    }
    getInventoryEventsFn(req, null);
  }

  const [eventsFiltered, setEventsFiltered] = useState([]);

  const [eventsLoading, setEventsLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [inventoryRender, setInventoryRender] = useState(1);
  const [loading, setLoading] = useState(true);

  const [calendarView, setCalendarView] = useState('all');

  const getInventoryEventsFn = async (req) => {
    setEventsLoading(true);
    let result = await getCalendarSchedule(req, inventoryRender);
    let _events = [];

    for (let k in result?.timecardEntryList) {

      let _e = {
        title: result?.timecardEntryList[k].employee.firstName + ' ' + result?.timecardEntryList[k].employee.lastName,
        start: formatDateMask(result?.timecardEntryList[k].startDate, 'YYYY-MM-DD HH:mm:ss'),
        end: formatDateMask(result?.timecardEntryList[k].startDate, 'YYYY-MM-DD HH:mm:ss'),
        displayTime: formatDateMask(result?.timecardEntryList[k].startDate, 'hh:mm a') + " - " + formatDateMask(result?.timecardEntryList[k].endDate, 'hh:mm a'),
        scheduledTime: result?.timecardEntryList[k]?.scheduledTime,
        employeeGuid: result?.timecardEntryList[k]?.employee?.guid,
        employee: result?.timecardEntryList[k]?.employee
      }
      _events.push(_e);
    }

    setEvents(_events);
    setEventsLoading(false);
    setInventoryRender(result?.inventoryRender);
    setLoading(false);
  }

  const eventClick = function (info) {
    navigate(`/company/employees/view/${info.event?.extendedProps?.employeeGuid}`);
  }

  const filterEvents = (events) => {
    let _events = [];
    for (let k in events) {
      let _e = events[k];
      if (calendarView === 'scheduled' && _e?.scheduledTime) {
        _events.push(_e);
      } else if (calendarView === 'worked' && !_e?.scheduledTime) {
        _events.push(_e);
      } else if (calendarView === 'all'){
        _events.push(_e);
      }
    }
    return _events;
  }

  useEffect(() => {
    setEventsFiltered(filterEvents(events));
  }, [events, calendarView])

  return (
    <DashboardLayout>

      <Meta
        pageTitle={'Employee Calendar'}/>

      <ContextSearchNavbar title={'Employee Calendar'}/>

      <MDBox py={3}>
        <Grid container spacing={3} cols={2}>
          <Grid item xs={12} sm={12}>

            <Card className={"mt-2"}>

              <div className={'my-2'}>
                <ButtonGroup className={'pull-right'}>
                  <Button
                    size="small"
                    key={'active'}
                    style={{
                      color: calendarView === 'all' ? '#fff' : '#111',
                      background: calendarView === 'all' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setCalendarView('all')
                    }}>
                    Active
                  </Button>

                  <Button
                    size="small"
                    key={'active'}
                    style={{
                      color: calendarView === 'scheduled' ? '#fff' : '#111',
                      background: calendarView === 'scheduled' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setCalendarView('scheduled')
                    }}>
                    Scheduled
                  </Button>

                  <Button
                    size="small"
                    key={'active'}
                    style={{
                      color: calendarView === 'worked' ? '#fff' : '#111',
                      background: calendarView === 'worked' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setCalendarView('worked')
                    }}>
                    Worked
                  </Button>

                </ButtonGroup>
              </div>

              <CardContent>
                <Grid item xs={12} xl={12}>
                  {useMemo(
                    () => (<FullCalendar
                      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                      initialView='dayGridMonth'
                      weekends={true}
                      height={'auto'}
                      contentHeight={'auto'}
                      eventContent={renderEventContent}
                      datesSet={handleDatesSet}
                      events={eventsFiltered}
                      headerToolbar={toolbar}
                      // dateClick={dateClick}
                      eventClick={eventClick}
                      // eventContent={renderEventContent}
                    />), [eventsFiltered]
                  )}
                </Grid>
              </CardContent>
            </Card>

          </Grid>
        </Grid>

      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
  );
}